<template>
  <div>
    <div class="nav" v-show="NatTop">
      <img class="bgImage" src="@/images/home/10-1.png" alt="" />
      <div class="content">
        <div class="logo">
          <img class="bgImage" src="@/images/home/1-1new.png" />
        </div>
        <div class="navbar">
          <router-link
            exact
            :to="item.path"
            custom
            v-slot="{ navigate }"
            v-for="(item, index) in this.$router.options.routes"
            :key="index"
            @click="navClick(index, item)"
          >
            <div class="box" @click="navigate">
              <div
                class="hexian"
                :class="
                  $store.state.navCurrentIndex == item.meta.id
                    ? 'nav_active_hexian'
                    : ''
                "
              ></div>
              <div
                class="wenzi"
                :class="
                  $store.state.navCurrentIndex == item.meta.id
                    ? 'nav_active_wenzi'
                    : ''
                "
              >
                {{ $store.state.i18n ? item.meta.title : item.meta.title_en }}
              </div>
              <div
                class="hexian"
                :class="
                  $store.state.navCurrentIndex == item.meta.id
                    ? 'nav_active_hexian'
                    : ''
                "
              ></div>
            </div>
          </router-link>
          <!-- <div class="box" v-for="(item,index) in this.$router.options.routes" :key="index" @click="navClick(index,item)">
            <div class="hexian" :class="this.$store.state.navCurrentIndex == item.meta.id?'nav_active_hexian':''"></div>
            <div class="wenzi" :class="this.$store.state.navCurrentIndex == item.meta.id?'nav_active_wenzi':''">{{item.meta.title}}</div>
            <div class="hexian" :class="this.$store.state.navCurrentIndex == item.meta.id?'nav_active_hexian':''"></div>
          </div> -->
        </div>
      </div>
      <div
        class="loginBox"
        :style="$store.state.i18n ? '' : 'width:8vw;right:6.567vw;'"
      >
        <div @click="onLogin()" class="login box">
          {{ $store.state.i18n ? componentsLang.pc.chinese.nav.login : componentsLang.pc.english.nav.login }}
        </div>
        <div @click="onRegister()" class="register box">
          {{ $store.state.i18n ? componentsLang.pc.chinese.nav.register : componentsLang.pc.english.nav.register }}
        </div>
      </div>
      <!-- 中英文切换 -->
      <div class="CnorEn" @click="CNorENClick()">
        <img
          v-show="$store.state.i18n"
          class="bgImage"
          src="@/images/english/i18n_en.png"
        />
        <img
          v-show="!$store.state.i18n"
          class="bgImage"
          src="@/images/english/i18n_zh.png"
        />
      </div>
    </div>
    <div class="nav post" v-show="selectNum">
      <img class="bgImage" src="@/images/home/10-1.png" alt="" />
      <div class="content">
        <div class="logo">
          <img class="bgImage" src="@/images/home/1-1new.png" />
        </div>
        <div class="navbar">
          <router-link
            exact
            :to="item.path"
            custom
            v-slot="{ navigate }"
            v-for="(item, index) in this.$router.options.routes"
            :key="index"
            @click="navClick(index, item)"
          >
            <div class="box" @click="navigate">
              <div
                class="hexian"
                :class="
                  $store.state.navCurrentIndex == item.meta.id
                    ? 'nav_active_hexian'
                    : ''
                "
              ></div>
              <div
                class="wenzi"
                :class="
                  $store.state.navCurrentIndex == item.meta.id
                    ? 'nav_active_wenzi'
                    : ''
                "
              >
                {{ $store.state.i18n ? item.meta.title : item.meta.title_en }}
              </div>
              <div
                class="hexian"
                :class="
                  $store.state.navCurrentIndex == item.meta.id
                    ? 'nav_active_hexian'
                    : ''
                "
              ></div>
            </div>
          </router-link>
        </div>
      </div>
      <div
        class="loginBox"
        :style="$store.state.i18n ? '' : 'width:8vw;right:6.567vw;'"
      >
        <div @click="onLogin()" class="login box">
          {{ $store.state.i18n ? componentsLang.pc.chinese.nav.login : componentsLang.pc.english.nav.login }}
        </div>
        <div @click="onRegister()" class="register box">
          {{ $store.state.i18n ? componentsLang.pc.chinese.nav.register : componentsLang.pc.english.nav.register }}
        </div>
      </div>
      <!-- 中英文切换 -->
      <div class="CnorEn" @click="CNorENClick()">
        <img
          v-show="$store.state.i18n"
          class="bgImage"
          :src="componentsLang.pc.chinese.nav.img"
        />
        <img
          v-show="!$store.state.i18n"
          class="bgImage"
          :src="componentsLang.pc.english.nav.img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { loginRedirect } from "@/api/login.js";
export default {
  data() {
    return {
      navList: [
        "首页",
        "产品服务",
        "科技赋能",
        "行业生态",
        "新闻中心",
        "关于我们",
        "加入我们"
      ], //导航数组,
      loginUrl: "", //登录重定向地址
      registerUrl: "", //注册重定向地址
      selectNum: false,
      NatTop: true
    };
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    // 在一开始获取路由信息
    let id = this.$route.meta.id;
    this.$store.commit("setNavCurrentIndex", id);

    // 获取登录，注册的重定向地址
    loginRedirect({
      data: {
        hideLoading: true
      },
      head: {
        terminalCode: "jdh_ent"
      }
    }).then(res => {
      this.loginUrl = res.data.data.loginUrl;
      this.registerUrl = res.data.data.registerUrl;
    });
    window.addEventListener("scroll", this.windowScroll, true);
    // this.NatTop();
  },
  methods: {
    // 登录
    onLogin() {
      window.location.href = this.loginUrl; //当前标签页
      //  window.open(src);          //打开一个新的标签页
    },
    // 注册
    onRegister() {
      window.location.href = this.registerUrl;
    },

    // 导航点击事件
    navClick(index, item) {
      this.$store.commit("setNavCurrentIndex", index);
      this.$router.push({ path: item.path });
    },
    // 中英文切换
    CNorENClick() {
		
      this.$emit("loadingShowClick", true);
      setTimeout(() => {
        this.$store.commit("setI18n");
        this.$router.go(0);
      }, 1500);
	  
    },
    windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop < 100) {
        this.selectNum = false;
        this.NatTop = true;
      } else {
        this.selectNum = true;
      }
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit("setNavCurrentIndex", to.meta.id);
    }
  }
};
</script>

<style scoped>
/* 导航 */
.bgImage {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.post {
  position: fixed !important;
  top: 0;
  z-index: 99999;
}
.nav {
  /* width:100%;height:4.688vw; */
  width: 100%;
  height: 2.916vw;
  /* background-color:#F8F9Fa; */
  /* background-color: orange; */
  /* border-bottom: 0.052vw solid #dbdFdF; */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav .content {
  width: 65.104vw;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.nav .content .logo {
  width: 10.125vw;
  height: 1.58vw;
  position: relative;
}
.nav .content .navbar {
  width: 40vw;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: orangered; */
}
.nav .content .navbar .box {
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* background-color: orchid; */
}
.nav .content .navbar .box .hexian {
  width: 0px;
  height: 0.208vw;
  background-color: #c22c33;
  transition: 0.1s;
}
.nav .content .navbar .box .wenzi {
  width: 100%;
  height: 2.083vw;
  padding-top: 0.521vw;
  padding-bottom: 0.521vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.938vw;
  color: #212529;
  font-weight: normal;
  /* background-color: palegreen; */
}
/* 导航栏选中样式 */
.nav .content .navbar .box:hover .hexian {
  width: 100%;
}
.nav .content .navbar .box:hover .wenzi {
  color: #000;
  /* font-weight:bold; */
}

/* 导航栏索引选中样式 */
.nav .content .navbar .box .nav_active_hexian {
  width: 100%;
}
.nav .content .navbar .box .nav_active_wenzi {
  color: #000;
  font-weight: bold;
}
/* 导航的登录，注册 */
.nav .loginBox {
  width: 6.513vw;
  height: 2.083vw;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8.067vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: orange; */
}
.nav .loginBox .box {
  width: auto;
  height: 1.771vw;
  color: #c22c33;
  font-size: 0.938vw;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0.313vw;
  transition: 0.3s;
  padding: 0.2vw;
  box-sizing: border-box;
}
/* 登录，注册选中样式 */
.nav .loginBox .box:hover {
  border: 0.052vw solid #c22c33;
  background-color: #f1e5e5;
}

/* 中英文切换 */
.nav .CnorEn {
  width: 1.94076vw;
  height: 2.016vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: white;
  right: 3vw;
  top: 50%;
  transform: translateY(-50%) scale(0.9);
  cursor: pointer;
  transition: 0.3s;
}
.nav .CnorEn:hover {
  transform: translateY(-50%) scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/nav/nav.vue